import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { IHookCallbacks } from 'src/hooks/common.hooks.interfaces';
import { GET_DOCUMENTS_LABELS_BY_COMPANY } from 'src/hooks/documents-labels/get-documents-labels.hook';

export const DELETE_DOCUMENT_TEMPLATE_BY_ID = gql`
  mutation deleteDocumentTemplateById($documentTemplateId: String!) {
    deleteDocumentTemplateById(documentTemplateId: $documentTemplateId) {
      _id
    }
  }
`;

export const useDeleteDocumentTemplateById = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation(['common', 'settings']);
  const [deleteDocumentTemplateById] = useMutation(DELETE_DOCUMENT_TEMPLATE_BY_ID, {
    onCompleted: onSuccess,
    refetchQueries: [GET_DOCUMENTS_LABELS_BY_COMPANY],
    onError: (error: any) =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('common:notifications.error.title'),
        ...(error && { description: error.errorMessage }),
      }),
  });

  return deleteDocumentTemplateById;
};
